import { localRuntimeDeviceTypeSchema, localRuntimePlatformFamilySchema } from "./local-runtimes.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/device-metadata.ts
const observedDeviceTypeSchema = localRuntimeDeviceTypeSchema;
const observedDeviceMetadataSchema = z$1.strictObject({
	observedDisplayName: z$1.string().trim().min(1).max(200).nullable(),
	platformFamily: localRuntimePlatformFamilySchema,
	osVersion: z$1.string().trim().min(1).max(120).nullable(),
	deviceType: observedDeviceTypeSchema,
	observedAtMs: z$1.number().int().nonnegative()
});
const writeCurrentDeviceObservedMetadataBodySchema = z$1.strictObject({ metadata: observedDeviceMetadataSchema });
const writeCurrentDeviceObservedMetadataResponseSchema = writeCurrentDeviceObservedMetadataBodySchema;
//#endregion
export { observedDeviceMetadataSchema, observedDeviceTypeSchema, writeCurrentDeviceObservedMetadataBodySchema, writeCurrentDeviceObservedMetadataResponseSchema };

//# sourceMappingURL=device-metadata.js.map